import Spinner from '@components/spinner/Spinner';
import CloseIcon from '@mui/icons-material/Close';
import {
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { BootstrapDialog } from './shared/BootstrapDialog';

export default function EstimationDialog({
  open,
  onClose,
  onAgree,
  title,
  description,
  estimateCredits,
  isEstimate,
  isLoading,
}) {
  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      aria-labelledby="survey-modal-title"
      maxWidth="md"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <Divider />

      {!isLoading && !isEstimate ? (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
          <Stack mt={2} spacing={0.5}>
            {estimateCredits && (
              <Stack mt={2} spacing={0.5}>
                <Typography variant="body" color="textSecondary">
                  Available Entitlements: <b>{estimateCredits?.credits_available}</b>
                </Typography>
                <Typography variant="body" color="textSecondary">
                  Required Entitlements: <b>{estimateCredits?.credits_required}</b>
                </Typography>
              </Stack>
            )}
          </Stack>
          <br />
          <a
            href="https://qualz.ai/pricing/#pricing-faq"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
              '&:visited': {
                color: 'primary.main',
              },
            }}
          >
            <Typography variant="body2">How Entitlements Work</Typography>
          </a>
        </DialogContent>
      ) : (
        <Spinner padding={7} />
      )}

      <DialogActions>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="contained" disabled={isLoading} onClick={onAgree}>
          {isLoading ? 'Confirming...' : 'Confirm'}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
